import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { BriefForm } from "../components/BriefForm";
import { CONTACT, IMG } from "../data/content";

export default function PlanEvent() {
  return (
    <main>
      <PageHero
        eyebrow="Plan Your Event"
        title="Tell Us What You Want People to Remember"
        description="Share your vision below. Our event team will review every brief personally — no instant quotations, only considered conversations."
        image={IMG.hero}
      />
      <section className="py-20 lg:py-28" data-testid="plan-event-page">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 grid lg:grid-cols-3 gap-14">
          <Reveal className="lg:col-span-2">
            <BriefForm />
          </Reveal>
          <Reveal delay={0.15}>
            <div className="border border-[#C9A55C]/20 bg-[#0D1018] p-8 space-y-6">
              <p className="text-xs uppercase tracking-[0.35em] text-[#C9A55C]">Prefer to Talk?</p>
              <p className="font-accent italic text-xl text-[#F3EEE5]/90 leading-relaxed">
                “Every great event begins with a conversation, not a quotation.”
              </p>
              <div className="space-y-3 text-sm text-[#A9ABB2]">
                <p>{CONTACT.phonePrimary}</p>
                <p>{CONTACT.phoneSecondary}</p>
                <p>{CONTACT.email}</p>
              </div>
              <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" className="btn-ghost w-full justify-center" data-testid="plan-whatsapp-btn">
                WhatsApp Our Team
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
